<template>
    <v-list-item
      data-testid="navigation-drawer-item-route"
      class="navigation-drawer-item-route"
      :to="route"
      v-if="allowedAccess"
    >
        <v-list-item-action>
            <v-icon
              v-if="icon !== ''"
              data-testid="navigation-drawer-item-icon"
              class="navigation-drawer-item-icon"
            >
              {{ icon }}
            </v-icon>
        </v-list-item-action>
        <v-list-item-content>
            <v-list-item-title
              data-testid="navigation-drawer-item-title"
              class="navigation-drawer-item-title"
            >
              {{ title }}
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
  props: {
    route_to: {
      type: String,
      required: true,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      required: true,
      default: ""
    },
    roles: {
      type: Array
    }
  },
  name: "NavigationDrawerItem",
  computed: {
    allowedAccess() {
      return this.userRole.some(role => this.roles.includes(role));
    },
    userRole() {
      return this.$store.state.user.roles;
    },
    route() {
      if (this.route_to === "/") {
        return `/`;
      } else {
        return { name: this.route_to };
      }
    }
  }
};
</script>
